<template>
	<div class="pageContainer app-container studentContainer">
		<el-row>
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">

				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="建档号" value="archive">建档号</el-option>
				<el-option label="准考证号" value="exam_num">准考证号</el-option>
				<el-option label="联系方式" value="phone">联系方式</el-option>
				<el-option label="地区" value="graduate_sch_city">地区</el-option>
				<el-option label="学制" value="xuezhi">学制</el-option>
				<el-option label="系部" value="xibu" />
				<el-option label="专业名称" value="zhuanye">专业名称</el-option>
				<el-option label="毕业学校" value="graduate_schname">毕业学校</el-option>
			</el-select>
			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
				style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />

			<el-select v-model="searchForm.xuezhi" clearable size="small" placeholder="学制"
				style="width: 150px;margin-right: 10px;">
				<el-option v-for="(item, index) in xuezhiArr" :key="index" :label="item.title" :value="item.title" />
			</el-select>

			<el-cascader ref="firstCascader" :options="treeData1" :props="treeProps1" size="small"
				v-model="searchForm.major_id" :show-all-levels="false" @change="handleCascaderChange" placeholder="系部专业"
				style="width: 50%;width: 200px;margin-right: 10px;" filterable clearable></el-cascader>


			<el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
			<el-button v-if="!donwClicked" size="small" icon="el-icon-download" @click="exportXls" plain type="primary">
				导出</el-button>
		</el-row>


		<Table :tableData="tableData" :page="page" :pmid="pmid" @handleModify="handleModify" @handleDel="handleDel"
			@handleSelectionChange="handleSelectionChange" @handlePageChange="handlePageChange"
			@handleSizeChange="handleSizeChange"></Table>


		<Form v-if="formshow" :stuid="stuid"></Form>

	</div>
</template>
<script>
import api from '@/api/api';
import Form from './ksdyzz/Form_dorm';
import Table from './ksdyzz/Table_dorm'
export default {
	name: 'Student',
	components: {
		Form,
		Table,
	},
	data() {
		return {
			searchForm: {
				ktype: 'stu_name',
				status: "all",
				xuezhi: "",
				major_id: 0
			}, //查询
			modalTitle: '添加学生',
			isadmin: this.$store.state.teacherRole.isadmin,
			showPrint: false,
			formshow: false,
			formshow_ksxg: false,
			showbtn: true,
			showSMs: false,
			//tree
			treeData: [],
			treeProps: {
				children: 'children',
				label: 'title'
			},
			treeData1: [],
			xuezhiValue: '',
			xuezhiArr: [],

			treeProps1: {
				children: 'children',
				label: 'title',
				value: 'id',
				checkStrictly: true,
				emitPath: false,
			},

			//table
			tabMapOptions: [{
				label: '住宿学生',
				key: 'notsp'
			},

			],
			activeName: 'notsp',
			tableData: [],
			page: {
				pageIndex: 1,
				pageSize: 20,
				pageSizes: [10, 20, 50],
				total: 0
			},
			multipleSelection: [],
			deptId: null,
			editOptions: {},
			teacherId: null,
			majorList: [],
			areaList: [],
			pmid: 1,
			AreaScores: [],
			casccaderLevel: 1,
			casccaderLabel: '',
			teacherInfo: {},
			stuid: 0,
			donwClicked: false
		}
	},

	created() {
		// init the default selected tab
		const tab = this.$route.query.tab
		if (tab) {
			this.activeName = tab
		}
	},
	mounted() {

		this.getOrgList();
		this.getOrgList1();
		this.getList()


		if (sessionStorage.getItem('userinfo')) {
			let userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
			console.log(userinfo.pmid)
			this.pmid = (userinfo && userinfo.pmid) ? userinfo.pmid : this.pmid
		}

	},
	methods: {

		getAreaScore() {
			//不按地区获取分数线，按学制获取分数线
			this.$http.post("/api/get_xuezhi_scoreline").then(res => {
				this.AreaScores = res.data

				this.getList();
			})

		},
		closePrint() {
			setTimeout(() => {
				this.showPrint = false
			}, 500)
		},
		getAreaSchoolList(id) {
			//this.areaList = area


			// let _this = this
			// this.$http.post(api.getSchoolAreaList).then(res => {
			// 	if (res.data && res.data.length > 0) {
			// 		_this.deleteEmptyGroup(res.data).then(result => {
			// 			this.areaList = area
			// 		})
			// 	}
			// })
		},
		//prepare for <Form>
		getOrgList() {
			let _this = this
			this.$http.post(api.stu_orgList).then(res => {
				let arr = []
				if (res.data && res.data.length > 0) {
					let resData = res.data
					resData.map(item => {
						let obj = Object.assign({}, item)
						if (obj.children && obj.children.length > 0) {
							obj.children.map(child => {
								delete child.children
							})
						}
						arr.push(obj)
					})
					_this.majorList = arr
				}
			})
		},
		getOrgList1() {
			let _this = this
			this.$http.post("/api/sch_major_list_and_num").then(res => {
				if (res.data && res.data.length > 0) {
					_this.deleteEmptyGroup(res.data).then(result => {
						let result1 = JSON.parse(JSON.stringify(result))
						let majorArr = [], xuezhiArr = []
						if (result1 && result1.length > 0) {
							result1.map(xibu => {
								let obj = JSON.parse(JSON.stringify(xibu))
								delete obj.children
								// majorArr.push(obj)
								if (xibu.children && xibu.children.length > 0) {
									xibu.children.map(major => {
										major.xibu_title = xibu.title
										if (major.children) {
											delete major.children
										}
										majorArr.push(major)
									})
								}
							})
							let groupList = this.groupBy(majorArr, function (item) {
								return [item.item_desc]
							})
							groupList && groupList.map(item => {
								let obj = {}
								obj.title = item[0].item_desc
								xuezhiArr.push(obj)
							})
							console.log(268, xuezhiArr)
							this.xuezhiArr = xuezhiArr
							this.treeData1 = result1
						}
					})
				}
			})
		},
		groupBy(array, f) {
			let groups = {};
			array.forEach(function (o) {
				let group = JSON.stringify(f(o));
				groups[group] = groups[group] || [];
				groups[group].push(o);
			});
			return Object.keys(groups).map(function (group) {
				return groups[group];
			});
		},

		// 处理没有children的分组
		deleteEmptyGroup(treeData) {
			return new Promise(resolve => {
				function traversal(data) {
					data.map(item => {
						for (let info in item) {
							if (item['children']) {
								if (item['children'].length > 0) {
									traversal(item['children'])
								}
								if (item['children'].length == 0) {
									delete item['children']
								}
							}
						}
					})
				}

				traversal(treeData)
				resolve(treeData)
			})
		},
		uploadFiles(e) {
			this.$http.post("/api/importStudents_ksdyzz_local", {
				url: e.src
			}).then(res => {
				this.$message.success("导入成功")
				if (res.data.msg.length > 0) {
					let html = ''
					for (let msg of res.data.msg) {
						html += "<div style='font-size:12px'>" + msg['姓名'] + ":" + msg.msg + "</div>"
					}
					this.$alert(html, '未导入数据', {
						dangerouslyUseHTMLString: true
					});


				}
				this.getList();



			})
		},
		uploadFiles2(e) {
			this.$http.post("/api/importStudents_ksdyzz_local", {
				url: e.src,
				type: "zz",
			}).then(res => {
				this.$message.success("导入成功")
				if (res.data.msg.length > 0) {
					let html = ''
					for (let msg of res.data.msg) {
						html += "<div style='font-size:12px'>" + msg['姓名'] + ":" + msg.msg + "</div>"
					}
					this.$alert(html, '未导入数据', {
						dangerouslyUseHTMLString: true
					});


				}
				this.getList();



			})
		},
		uploadFiles5Year(e) {
			this.$http.post("/api/importStudents5year", {
				url: e.src
			}).then(res => {
				this.$message.success("导入成功")
				if (res.data.msg.length > 0) {
					let html = ''
					for (let msg of res.data.msg) {
						html += "<div style='font-size:12px'>" + msg['姓名'] + ":" + msg.msg + "</div>"
					}
					this.$alert(html, '未导入数据', {
						dangerouslyUseHTMLString: true
					});


				}
				this.getList();



			})
		},

		refreshData() {
			console.log(this.activeName)
			this.getList()
		},

		//table
		getList() {
			this.tableData = []
			let params = {
				page: this.page.pageIndex,
				pagesize: this.page.pageSize,
				xuezhi: this.searchForm.xuezhi,
				major_id: this.searchForm.major_id,

				status: 3,
			}

			params.ktype = this.searchForm.ktype
			params.keyword = this.searchForm.keyword



			this.$http.post("/api/t_sch_stu_dorm_list", params).then(res => {
				for (let item of res.data.data) {
					let city = item.graduate_sch_city.split(",")

					if (city.length >= 3) {
						item.city = city[1]
					} else {
						city = city[0]
						if (city.indexOf("市") > 0) {
							item.city = city.split("市")[0]
							if (city.indexOf("省") > 0) {
								item.city = city.split("省")[1]

							}
						}
					}

					//计算分数是否达标
					item.scoreOk = false;
					for (let p of this.AreaScores) {
						if (p.kname == item.xuezhi) {
							if (p.kvalue <= item.exam_score) {

								item.scoreOk = true
							}
							break
						}

					}
				}
				this.tableData = res.data.data
				this.page.total = res.data.page.count
				if (res.data.teacherMajors && res.data.teacherMajors.length == 1) {
					this.searchForm.dept_id = res.data.teacherMajors[0].id
				}
			})
		},
		handleNodeClick(data) {
			this.deptId = data.id
			// this.tabMapOptions[0].label=`${data.title}`
			this.getList()
		},
		formAdd() {
			let _this = this
			this.showbtn = true
			this.modalTitle = '添加学生'
			this.editOptions = {
				status: 0,
				stu_type: 0
			}
			if (_this.pmid == 5) {
				// console.log(this.areaList)
				this.editOptions.graduate_dist_code = "320501"
				this.editOptions = {
					..._this.editOptions
				}
			}
			setTimeout(function () {
				_this.showForm()
			}, 50)
		},
		handleModify(row) {
			if (row.ksxiugai) {//只修改住宿和备注

				this.modalTitle = '修改学生';
				this.teacherId = row.teacher_id
				this.showbtn = row.showbtn
				this.editOptions = row
				this.formshow_ksxg = true
			} else {
				let _this = this
				this.modalTitle = '修改学生';
				this.teacherId = row.teacher_id
				this.showbtn = row.showbtn
				this.editOptions = row
				setTimeout(function () {
					_this.showForm()
				}, 50)
			}
		},
		handleDel(row) {
			this.$http.post(api.stuDel, {
				ids: String(row.id)
			}).then(res => {
				this.$message.success('删除成功')
				this.getList();
			})
		},
		handlePageChange(e) {
			this.page.pageIndex = e
			this.getList()
		},
		handleSizeChange(e) {
			this.page.pageSize = e
			this.getList()
		},
		handleSelectionChange(val) {
			let _this = this;
			_this.multipleSelection = val;
		},
		showForm() {
			this.formshow = true
		},
		saveForm(e, f) {

			console.log(e)
			let _this = this
			this.$http.post(api.stuSave, e).then(res => {
				if (f && res.data.id) {
					f.stu_id = res.data.id
					this.$http.post("/api/t_sch_stu_fee_edit", f).then(res => {
						if (this.$store.state.pmid == 1) { //南高职自动弹出打印收费单
							this.editOptions.id = f.stu_id
							this.showPrint = true
							console.log(this.showPrint)
						}
					})
				} else {
					if (e.id) {
						if (f) {
							f.stu_id = e.id
							this.$http.post("/api/t_sch_stu_fee_edit", f).then(res => {
								if (this.$store.state.pmid == 1) { //南高职自动弹出打印收费单
									this.editOptions.id = f.stu_id
									this.showPrint = true
									console.log(this.showPrint)
								}
							})
						}
					}
				}
				this.$message.success('保存成功')
				this.formshow = false
				this.formshow_ksxg = false
				setTimeout(function () {
					_this.getList();

				}, 100)
			})
		},
		onSearch() {
			this.tableData = [];
			this.page.pageIndex = 1;
			this.getList();
		},
		onReset() {
			this.searchForm = {
				ktype: 'stu_name'
			};
			this.tableData = [];
			this.page.pageIndex = 1;
			this.getList();
		},
		handleSelectionChange(val) {
			let _this = this;
			_this.multipleSelection = val;
		},
		mutiDel() {
			let ids = ''
			if (this.multipleSelection && this.multipleSelection.length > 0) {
				ids = this.multipleSelection.map((item, index) => {
					return item.id
				}).join(',')
				this.handleDel({
					id: ids
				})
			} else {
				this.$message.warning('请至少选择一条数据')
			}
		},

		handleCascaderChange(e, opt) {
			let node = this.$refs['firstCascader'].panel.getNodeByValue(e)
			console.log(563, e, node, node.level, node.label)
			this.casccaderLabel = node.label
			this.casccaderLevel = node.level
		},
		exportStudents() {
			let params = {
				status: this.searchForm.status,
				stu_type: "all",
				list_type: 3,
			};
			params.ktype = this.searchForm.ktype;
			params.keyword = this.searchForm.keyword;
			params.ids = this.multipleSelection
				.map((e) => {
					return e.id;
				})
				.join(",");

			this.$http.post("/api/exportStudents", params).then((res) => {
				if (res.data.url) {
					window.open(res.data.url);
				}
			});
		},
		sendSms() {

		},
		exportXls() {
			this.donwClicked = true
			this.$http.post("/api/check_ksdyzz_dorm_file").then(res => {
				if (res.data.data) {
					let file = JSON.parse(res.data.data)
					console.log(file)
					window.open(file.url, "_blank")
				} else {
					this.$http.post("/api/export_ksdyzz_dormlist").then(res => {

						this.$alert(res.data.msg, '导出提示', {
							confirmButtonText: '确定',
							callback: action => {

							}
						});
						let t = setInterval(() => {
							this.$http.post("/api/check_ksdyzz_dorm_file").then(res => {
								if (res.data.data) {
									clearInterval(t)
									let file = JSON.parse(res.data.data)
									
									window.open(file.url, "_blank")
								}
							})
						}, 2000)
					})

				}
			})

		}
	}
}
</script>

<style lang="less" type="text/less">
.studentContainer {
	.el-tabs__nav {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.el-tabs__item {
		line-height: unset;
		display: flex;
		align-items: center;
	}

	.el-tabs__item.is-disabled {
		color: #303133;
		cursor: default
	}

	.el-tabs__item.is-active {
		color: #409EFF;
	}
}
</style>
<style scoped lang="less" type="text/less">
.app-container {
	.treeContainer {
		height: 100%;
		background-color: #fff;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
		border: 1px solid rgba(220, 223, 230, 0.6);

		.treeTitle {
			height: 40px;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			color: #409eff;
			padding-left: 6px;
		}
	}
}
</style>
